import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <iframe width="760" height="430" src="https://www.youtube.com/embed/llabWVjyP8Q" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <p>{`To Get Started with the `}<inlineCode parentName="p">{`Reactive V4.*`}</inlineCode>{` at First you download `}<strong parentName="p">{`All files & documentation,`}</strong></p>
    <p>{`After download the full package (`}<strong parentName="p">{`All files & documentation`}</strong>{`) from `}<a parentName="p" {...{
        "href": "http://codecanyon.net/user/redqteam"
      }}>{`codecanyon`}</a>{` , you will get `}<inlineCode parentName="p">{`codecanyon-17425763-reactive-pro-advanced-wordpress-search-filtering-grid (1).zip`}</inlineCode>{` file.`}</p>
    <p><img alt="main-plugin-files.png" src={require("./images/main-plugin-files.png")} /></p>
    <p>{`Now you have to unzip this file `}<strong parentName="p">{`(NB: This is not the Installable plugin file so if you try to upload and install this file you will get a stylesheet not found error).`}</strong>{` After you Unzip the the `}<strong parentName="p">{`codecanyon-17425763-reactive-pro-advanced-wordpress-search-filtering-grid (1).zip`}</strong>{` file you will find a folder name `}<strong parentName="p">{`Reactive Pro - React Powered Search Page Builder.`}</strong></p>
    <p>{`Inside this Folder you will find some necessary folder and files.`}</p>
    <p><img alt="all-file-inside-reactivepro.png" src={require("./images/all-file-inside-reactivepro.png")} /></p>
    <p>{`Now first create a zip version of the `}<strong parentName="p">{`reactivepro`}</strong>{` folder,`}</p>
    <p>{`or you can directly download the `}<strong parentName="p">{`Installable wordpress file only`}</strong>{` from the Codecanyon and put it to the `}<strong parentName="p">{`Reactive Pro - React Powered Search Page Builder`}</strong>{` Folder,`}</p>
    <p>{`After you created or downloaded the zip version of the `}<inlineCode parentName="p">{`reactivepro`}</inlineCode>{` folder, now you can start installing them.`}</p>
    <p>{`At first install the plugin from the `}<strong parentName="p">{`helpers plugin folder`}</strong>{`. This plugins are `}<strong parentName="p">{`recommended`}</strong>{` to work properly with the Reactive Pro plugin so you must have to install them.`}</p>
    <p>{`so you have to upload & install the below Plugin zip file,`}</p>
    <p>{`i) `}<inlineCode parentName="p">{`redq-reuse-form.zip`}</inlineCode></p>
    <p>{`ii) `}<inlineCode parentName="p">{`googlemap.zip`}</inlineCode>{` (this plugin is only needed if you want to use the map feature of the plugin otherwise you don't have the install it)`}</p>
    <p>{`iii) `}<inlineCode parentName="p">{`reactivepro.zip`}</inlineCode></p>
    <h3 {...{
      "id": "install-from-wordpress-back-end"
    }}>{`Install from wordpress back-end:`}</h3>
    <pre><code parentName="pre" {...{}}>{`1. Go to wordpress Dashboard-> plugins -> add new.
2. From here click upload plugins button, then you will find the plugin upload window.
3. Upload 'redq-reuse-form.zip' then click install now button.
4. After successfully install the plugin then active it.
5. Similarly, install the \`googlemap.zip\` plugin.
6. And after installing the \`RedQ reuse form\` and \`Google Map\` plugin, Upload 'reactive.zip' and install this plugin.
`}</code></pre>
    <p><img alt="install.png" src={require("./images/install.png")} /></p>
    <p>{`So I Assume, At this point you have installed the Redq Reuse From & Reactive pro plugin installed Successfully, To check Everything is installed properly make sure you have all the options like the below image available in your admin section,`}</p>
    <p>{`If there is anything wrong like you don't find the Google map Menu, the Geobox menu don't have a post type select box again make sure you have `}<strong parentName="p">{`__RedQ Reuse Form & Reactivepro`}</strong>{` plugin activated in your plugin section,`}</p>
    <blockquote>
      <p parentName="blockquote">{`NB: The current version of of Redq Reuse Form & Reactive Pro is 5.0.1`}</p>
    </blockquote>
    <p>{`That's It, You have successfully Installed the Reactive Pro. Follow the next Section To Setup The Plugin.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      